<div class="row">
	<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
		<mat-card appearance="outlined" style="min-width:350px;">
			<h2 style="padding-left:18px;padding-top:5px;">
				Login Audits
			</h2>
			<mat-card-content>
				<div class="row">
					<mat-form-field appearance="fill" style="width: 100%; font-size:15px;">
						<mat-label>Enter a date range</mat-label>
						<mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
						<mat-date-range-input [formGroup]="range" [rangePicker]="picker">
							<input matStartDate formControlName="start" style="font-size:small;" placeholder="Start date">
							<input matEndDate formControlName="end" style="font-size:small;"  placeholder="End date">
						</mat-date-range-input>

						<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
						<mat-date-range-picker #picker></mat-date-range-picker>

						<mat-error *ngIf="start.hasError('matStartDateInvalid')">Invalid start date
						</mat-error>
						<mat-error *ngIf="end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
					</mat-form-field>
				</div>


				<region-dropdown-two-way [isMultiple]="true" [(selectedRegions)]="lstSelectedRegion"
					[reset]="resetField" [selectUserRegion]="true">
				</region-dropdown-two-way>
			</mat-card-content>
			<mat-card-actions>
				<div class="row">
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
					
						<span><button mat-raised-button color="primary" mat-button [disabled]="!validateSearchEnable()"
						(click)="search()" style="padding-bottom:5px;">Search</button>&nbsp;&nbsp;
						<button mat-raised-button color="accent" (click)="resetSearchFields()" style="padding-bottom:5px;" mat-button>Reset</button></span>
					</div>
				</div>
			</mat-card-actions>
		</mat-card>
	</div>
</div>

<div class="row" style="margin-top: 15px;" *ngIf="this.lstLoginAudit.length>0">
	<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
		<mat-form-field style="width: 100%">
			<mat-label>Filter Results</mat-label>
			<input matInput [formControl]="searchTextCtrl" placeholder="Filter Search Results">
			<mat-icon matSuffix>search
			</mat-icon>
		</mat-form-field>
	</div>
</div>

<div>
	<mat-table *ngIf="this.dataSource.data.length>0" [dataSource]="dataSource" matSort
		(matSortChange)="announceSortChange($event)"  class="table-responsive" style="width:100%;table-layout:fixed;">

		<ng-container matColumnDef="LOGINTIME">
			<th mat-header-cell *matHeaderCellDef mat-sort-header style="width:30%;min-width: 120px; padding: 8px 16px;">Login Time</th>
            <td mat-cell *matCellDef="let element;let i = index" style="width:30%;min-width: 120px; padding: 8px 16px;">
				{{element.LOGIN_TIME | date:'MMM d, y, @ h:mm a'}}
			</td><!-- class="midHeader"  class="flushUpHovers"   -->
		</ng-container>
		<ng-container matColumnDef="LOGOUTTIME">
			<th mat-header-cell *matHeaderCellDef mat-sort-header style="width:30%;min-width: 120px; padding: 8px 16px;">Logout Time</th>
			<td mat-cell *matCellDef="let element;let i = index" style="width:30%;min-width: 120px; padding: 8px 16px;">
				{{element.LOGOUT_TIME| date:'MMM d, y, @ h:mm a'}}
			</td>
		</ng-container>
		<ng-container matColumnDef="USERNAME">

			<th mat-header-cell *matHeaderCellDef mat-sort-header style="width:30%;min-width: 120px; padding: 8px 16px;">Username</th>
			<td mat-cell *matCellDef="let element;let i = index" style="width:30%;min-width: 120px; padding: 8px 16px;">
				{{element.LOGIN_DETAILS.USER_ID}}
			</td>

		</ng-container>
		<ng-container matColumnDef="NAME">
			<th mat-header-cell *matHeaderCellDef mat-sort-header style="width:30%;min-width: 120px; padding: 8px 16px;">Name</th>
			<td mat-cell *matCellDef="let element;let i = index" style="width:30%;min-width: 120px; padding: 8px 16px;">
				{{element.LOGIN_DETAILS.PERSON.FIRST_NAME + " "}}
				{{element.LOGIN_DETAILS.PERSON.LAST_NAME}}
			</td>
		</ng-container>
		<ng-container matColumnDef="REGION">
			<th mat-header-cell *matHeaderCellDef mat-sort-header style="width:30%;min-width: 120px; padding: 8px 16px;">Region</th>
			<td mat-cell *matCellDef="let element;let i = index" style="width:30%;min-width: 120px; padding: 8px 16px;">
				{{element?.REGION.CODE}}
			</td>

			<mat-header-cell *matHeaderCellDef>
				<h3> Region </h3>
			</mat-header-cell>

			<!-- <mat-cell *matCellDef="let element">
				{{element?.REGION.CODE}}
			</mat-cell> -->
		</ng-container>
<!--		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
-->
		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let i = index; let row; columns: displayedColumns;"  ></tr>    
	</mat-table>

</div>
	<mat-paginator #searchPaginator [length]="dataSource.data.length" [pageSizeOptions]="[5, 10, 20]"
		showFirstLastButtons aria-label="Select page of periodic elements">
	</mat-paginator>

